import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import { JwtModule } from '@auth0/angular-jwt';
import { LayoutComponent } from './layout/layout.component';
// import {MatInputModule, MatButtonModule} from '@angular/material';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CustomMaterialModule } from './../material.module';
import { ImpersonateComponent } from './impersonate/impersonate.component';
import { SsoLoginComponent } from './sso-login/sso-login.component';

export function tokenGetter() {
  return sessionStorage.getItem('userToken');
}

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    CustomMaterialModule,
    // MatInputModule,
    // MatButtonModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    })
  ],
  declarations: [LoginComponent, LayoutComponent, ResetPasswordComponent, ImpersonateComponent, SsoLoginComponent]
})
export class AuthModule { }
